import React from 'react'
import { cn } from '@s4l/utility-css'
import styles from './index.module.css'

interface SeparatorProps {
  orientation?: 'horizontal' | 'vertical'
  size?: 'small' | 'medium' | 'large'
  color?: string
  className?: string
  style?: React.CSSProperties
}

export default function Separator({
  orientation = 'horizontal',
  size = 'medium',
  color = 'var(--color-neutral-400)',
  className,
  style,
  ...rest
}: Readonly<SeparatorProps>) {
  return (
    <hr
      className={cn(styles.separator, styles[orientation], className)}
      data-size={size}
      style={{ backgroundColor: color, ...style }}
      {...rest}
    />
  )
}
